import { httpRequest } from "../../../utils/HttpRequest";
import { ciHttpRequest } from '@/utils/CiHttpRequest';
import { IKey, IMdCmFields, IPage, ISearchPageField } from "../../../types/FmsTypes";
import { trasDsToTreeData } from "./dictModel";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

export interface IMdDictFields extends IMdCmFields {
    code?: string;
    name?: string;
    pcode?: string;
    value?: string,
    note?: string;
    children?: IMdDictDetail[];
}

export type IMdDictDetail = IKey & IMdCmFields & IMdDictFields;
export type IMdDictSearch = IMdDictFields & ISearchPageField;

export interface CiDictField {
    dictCode: string,
    dictNumber: string,
    title: string,
    children?: CiDictField[];
}

class DictService {
    async insert(insertVo: IMdDictFields) {
        const apiUrl = "/dict/insert";
        return await httpRequest.post<IMdDictDetail>(apiUrl, insertVo);
    }

    async update(updateVo: IMdDictFields) {
        const apiUrl = "/dict/update";
        return await httpRequest.post<IMdDictDetail>(apiUrl, updateVo);
    }

    async disable(oneVo: IMdDictFields) {
        const apiUrl = "/dict/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }

    async find(searchVo: IMdDictFields) {
        const apiUrl = "/dict/find";
        return await httpRequest.post<IMdDictDetail[]>(apiUrl, searchVo)
    }

    async dictItemDs(pcode: string,) {
        let { retData } = await this.find({ pcode })
        return retData?.filter(item => item.enable).map(el => ({
            label: el.name ?? "",
            value: el.code ?? "",
            type: el.value ?? ""
        }))
    }

    async page(searchVo: IMdDictSearch) {
        const apiUrl = "/dict/page";
        return await httpRequest.post<IPage<IMdDictDetail>>(apiUrl, searchVo)
    }

    async one(oneVo: IMdDictFields) {
        const apiUrl = "/dict/one";
        return await httpRequest.post<IMdDictDetail>(apiUrl, oneVo)
    }

    async allTree(searchVo: IMdDictFields) {
        const apiUrl = "/dict/allTree";
        searchVo.branchList = ["main", "fms"];
        return await httpRequest.post<IMdDictDetail[]>(apiUrl, searchVo)
    }

    async oneTree(oneVo: IMdDictFields) {
        const apiUrl = "/dict/oneTree";
        return await httpRequest.post<IMdDictDetail>(apiUrl, oneVo)
    }

    async oneTreeDs(oneVo: IMdDictFields) {
        let { retData } = await this.oneTree(oneVo);
        let { children } = retData
        return children ? children.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        })) : []
    }

    async sync(searchVo: IMdDictFields) {
        const apiUrl = "/dict/sync";
        // searchVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT })
    }

    async syncPage(searchVo: IMdDictSearch) {
        const apiUrl = "/dict/syncPage";
        searchVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(apiUrl, searchVo)
    }

    async syncOne(oneVo: IMdDictFields) {
        const apiUrl = "/dict/syncOne";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }
    async accountTreeOne(code: string) {
        let { retData } = await this.allTree({ code })
        // return retData.map(el => ({
        //     label: el.name ?? "",
        //     value: el.code ?? "",
        //     codes: el.value ?? "",
        // }))
        let { children } = retData[0]
        let treeData = trasDsToTreeData(children as IMdDictFields[], "code", "name");
        return treeData;
    }

    async getCiDictAll() {
        const apiUrl = `/ci/dict/tree`;
        return await ciHttpRequest.get<CiDictField[]>(apiUrl);
    }
}
export const dictService = new DictService();
